import React, { Component } from 'react';
import { Form, Label, Button, Dropdown } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class UrineTest extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="UrineTest">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="UrineTest__Form"
        >
          <h1>{translate('fiche.urine_test.title')}</h1>

          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.urine_test.protein')} />
              <Dropdown
                name="protein"
                rules={['required']}
                defaultValue={data.protein}
                data={['-', '+', '++', '+++']}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.urine_test.sugar')} />
              <Dropdown
                name="sugar"
                rules={['required']}
                defaultValue={data.sugar}
                data={['-', '+', '++', '+++']}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.urine_test.blood')} />
              <Dropdown
                name="blood"
                rules={['required']}
                defaultValue={data.blood}
                data={['-', '+', '++', '+++']}
              />
            </div>
          </div>

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(UrineTest);
